// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-alert {
  background-color: #c4453c;
  background-image: linear-gradient(135deg, transparent, transparent 25%, hsla(0, 0%, 0%, 0.1) 25%, hsla(0, 0%, 0%, 0.1) 50%, transparent 50%, transparent 75%, hsla(0, 0%, 0%, 0.1) 75%, hsla(0, 0%, 0%, 0.1));
  background-size: 20px 20px;
  color: #f6f6f6;
  display: block;
  font: bold 14px/40px sans-serif;
  text-decoration: none;
  width: 100%;
  min-height: 40px;
  line-height: 20px;
  padding-bottom: 10px;
}
.header-alert a {
  color: white;
  text-decoration: underline;
}

p {
  margin: 0;
  padding: 20px;
  padding-bottom: 0;
}

ul {
  margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/signalr-routing-hub/signalr-routing-hub.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,6MAAA;EAWA,0BAAA;EACA,cAAA;EACA,cAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AATF;AAWE;EACE,YAAA;EACA,0BAAA;AATJ;;AAaA;EACE,SAAA;EACA,aAAA;EACA,iBAAA;AAVF;;AAaA;EACE,aAAA;AAVF","sourcesContent":[".header-alert {\r\n  background-color: #c4453c;\r\n  background-image: linear-gradient(\r\n    135deg,\r\n    transparent,\r\n    transparent 25%,\r\n    hsla(0, 0%, 0%, 0.1) 25%,\r\n    hsla(0, 0%, 0%, 0.1) 50%,\r\n    transparent 50%,\r\n    transparent 75%,\r\n    hsla(0, 0%, 0%, 0.1) 75%,\r\n    hsla(0, 0%, 0%, 0.1)\r\n  );\r\n  background-size: 20px 20px;\r\n  color: #f6f6f6;\r\n  display: block;\r\n  font: bold 14px/40px sans-serif;\r\n  text-decoration: none;\r\n  width: 100%;\r\n  min-height: 40px;\r\n  line-height: 20px;\r\n  padding-bottom: 10px;\r\n\r\n  a {\r\n    color: white;\r\n    text-decoration: underline;\r\n  }\r\n}\r\n\r\np {\r\n  margin: 0;\r\n  padding: 20px;\r\n  padding-bottom: 0;\r\n}\r\n\r\nul {\r\n  margin-top: 0;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
